import { useState } from 'react'
import Table from './Table';
const Tab2 = ({ setTaxes,taxes,compname}) => {
  const [selected_item_data, setselected_item_data] = useState([]);
  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Taxes and Chargess</p>
        <Table   taxes={taxes} setTaxes={setTaxes}  compname={compname}    />
      </div>
      <div>
       

      </div>
    </div>
  )
}

export default Tab2